import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import PublicChat from '@/pages/PublicChat';
import LoginPage from '@/pages/LoginPage';
import AdminDashboard from '@/pages/AdminDashboard';
import LandingPage from '@/pages/LandingPage';
import VaterstettenWidgetPage from '@/pages/VaterstettenWidgetPage';
import DemoWidgetPage from '@/pages/DemoWidgetPage';
import ChangePasswordPage from '@/pages/ChangePasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/chat" element={<ErrorBoundary><PublicChat /></ErrorBoundary>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/admin" element={<ErrorBoundary><AdminDashboard /></ErrorBoundary>} />
          <Route path="/vaterstetten" element={<VaterstettenWidgetPage />} />
          <Route path="/:slug" element={<DemoWidgetPage />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
